import React from "react";

export default function AccountPreferences({
  preferences,
  handlePrefChange,
  savePreferences,
  saveStatus,      // null | "saving" | "saved" | "error"
  unsavedChanges,  // boolean
}) {
  return (
    <>
      <h2>Preferences</h2>

      <div className="account-content-subcontainer">
        <div className="account-content-subcontainer-item">
          <label style={{ display: "block", marginBottom: 8 }}>
            <input
              type="checkbox"
              checked={Boolean(preferences.emailNotifications)}
              onChange={handlePrefChange("emailNotifications")}
            />{" "}
            Receive order & shipping updates
          </label>

          <label style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={Boolean(preferences.marketingEmails)}
              onChange={handlePrefChange("marketingEmails")}
            />{" "}
            Receive marketing & promo emails
          </label>
        </div>

        <br />

        <div className="account-content-subcontainer-item account-content-subcontainer-item-save-button">
          {unsavedChanges && (
            <button
              type="button"
              onClick={savePreferences}
              disabled={saveStatus === "saving"}
              style={{ marginRight: 12 }}
            >
              {saveStatus === "saving" ? "Saving..." : "Save Preferences"}
            </button>
          )}

          {saveStatus === "saved" && <i style={{ color: "green" }}>Saved</i>}
          {saveStatus === "error" && <i style={{ color: "red" }}>Error saving</i>}

          <div style={{ marginTop: 8 }}>
            <small>
              {unsavedChanges
                ? "You have unsaved changes."
                : "All preferences saved."}
            </small>
          </div>
        </div>
      </div>
    </>
  );
}
